var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.41,
    height: 71.297,
    viewBox: "0 0 67.41 71.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122546",
    "data-name": "Group 122546",
    transform: "translate(285.11 -22368.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171715",
    "data-name": "Path 171715",
    d: "M776.559,175.092c6.564,0,12.493-.045,18.422.012,6.408.063,8.29,1.891,8.288,8.386,0,6.141.232,12.348-.549,18.409-1.2,9.331-8.334,16.333-17.629,16.891-9.924.6-19.912.135-30.373.135-.148-1.521-.4-2.934-.406-4.347-.031-12.145-.07-24.291.04-36.436a13.733,13.733,0,0,1,1.247-5.724c3.2-6.566,6.707-12.983,9.99-19.511,1.929-3.836,4.952-5.46,8.991-4.266,4.065,1.2,4.948,4.429,4.371,8.352-.839,5.71-1.521,11.442-2.392,18.1",
    transform: "translate(-1021 22220)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171716",
    "data-name": "Path 171716",
    d: "M749.433,218.671c-13.505,1.854-13.521,1.854-13.531-10.888-.006-9.291.158-18.584-.009-27.871-.065-3.558.865-5.262,4.733-4.86,2.778.288,5.609.056,8.807.056Zm-5.285-15.6c-3.07,2.344-2.546,5.2-1.366,8.006.2.477,1.622.441,2.478.642.073-2.616.162-5.233.183-7.85,0-.166-.524-.336-1.295-.8",
    transform: "translate(-1021 22220)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.fecc645929e032ada7b888185690661d.svg";
export { ForwardRef as ReactComponent };